import { User } from "../classes/user/User";

export interface LoginRequest {
    user: EmailLoginData | TelegramLoginData;
    loginMethode: LoginMethod
}
export enum LoginMethod {
    email,
    telegram
}

export interface EmailLoginData {
    email: string;
    password: string;
}
export type TelegramLoginData = {
    mode?: "widget" | "miniapp";
    queryString:string;
    hash: string;
    user: TelegramUser;
    username: string;
    firstName?: string;
    lastName?: string;
    authDate: string;
    widgetUser?: TelegramWidgetUser;
}
export type TelegramUser = {
    id:number;
    first_name:string;
    last_name:string;
    username:string;
    language_code:string;
    allows_write_to_pm:boolean;
}

export type TelegramWidgetUser = {
    id:number;
    first_name:string;
    last_name:string;
    username:string;
    photo_url:string;
    auth_date:string;
    hash:string;
}
